// extracted by mini-css-extract-plugin
export var imageBg = "Background-module--imageBg--d564b";
export var mainPage = "Background-module--mainPage--7699d";
export var videoBg = "Background-module--videoBg--e310d";